import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ProviderReportList, { DispatchProps, OwnProps, StateProps } from './ProviderReportList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import {
    getProviderReports,
    getProviderReportsCsv,
    getProviderReportsTotal,
    clearTotal,
} from 'src/store/actions/providerReport-actions';

import { getProvidersSmall } from '../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../store/selectors/providers-selectors';
import { getServiceTypes } from '../../../../../store/actions/service-type-actions';
import { getServiceLocations } from '../../../../../store/actions/service-location-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.providerReports.data,
        inProgress: state.providerReports.inProgress,
        providers: selectNameProviders(state),
        totals: state.providerReports.totals,
        serviceTypes: state.serviceTypes.data,
        serviceLocations: state.serviceLocations.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getProviderReports(params)),
        getDataCsv: (params: QueryParams) => dispatch(getProviderReportsCsv(params)),
        getDataTotal: (params: QueryParams) => dispatch(getProviderReportsTotal(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        clearTotal: () => dispatch(clearTotal()),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
    };
}

const ProviderReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProviderReportList);

export default ProviderReportListScreen;
